// extracted by mini-css-extract-plugin
export default {"examTaskDetails":"ExamTaskDetails_examTaskDetails__aQJma","infinity":"ExamTaskDetails_infinity__j+dMt","tasks":"ExamTaskDetails_tasks__Xy1yF"};